import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ isLoggedIn, requireExecute, hasExecute, children }) => {
  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  // Si la ruta requiere 'execute' y el usuario no tiene el permiso, redirige
  if (requireExecute && !hasExecute) {
    return <Navigate to="/" />; // Puedes crear una página de "Acceso Denegado" o redirigir a otra ruta
  }

  return children;
};

export default ProtectedRoute;
